import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { global_variables } from 'src/environments/global_variables';

@Injectable({
   providedIn: 'root',
})
export class UserAccessebiltyService {
   constructor(private _authService: AuthService) {}

   isInRole(allowedRoles: string[]) {
      // check if any of the user roles are in the allowed roles array

      const strUserRole = this._authService.userData['action']['role'];
      const hasAccess: boolean = allowedRoles.includes(strUserRole);

      return hasAccess;
   }

 

   getUserId() {
      return this._authService.currentUserId;
   }

   getUserRole(): string {
      return this._authService.userData['action']['role'];
   }

   getUserFeature(): string[] {
      // console.log('userData:', this._authService?.userData);
      return this._authService?.userData?.['action']?.features ?? [];
    }

   getUserType(): string {
      return this._authService.isUserStaff ? global_variables['userTypes'][0] : global_variables['userTypes'][1];
   }

   isStaff(): boolean {
      return this.getUserType() === global_variables['userTypes'][0];
   }

   isCustomer(): boolean {
      return this.getUserType() === global_variables['userTypes'][1];
   }
}
